
import styles from "./NavigationLinks.module.css";
import { NavLink } from "react-router-dom"

const NavigationLinks = ({ 
    linkText, 
    to, 
    onClick, 
    // key,
    styleName='default', 
    children,
    color

}) => {

    const linkStyles = `${styles.navigationLinksContainer} ${styles[styleName]}`;

    return (
        <span className={linkStyles}>
            { to ?
             <NavLink
             style={{color:color}}
                // key={key}
                onClick={onClick}
                className={({ isActive }) => isActive ? styles.active : undefined}
                to={to}
            >
                {linkText}{children}
            </NavLink>
            :
            <p></p>
        }  
        </span>
    );
}

export default NavigationLinks;